import { useEffect } from 'react';
import { sendMessageToNative } from '../features/nativeBridge';

export const LoggerClient = () => {
  useEffect(() => {
    if (window.ReactNativeWebView && process.env.NODE_ENV === 'development') {
      console.log('%cLoggerClient routing to native console', 'background:green; color:white;');
      window.console.log = (...args: unknown[]) => {
        sendMessageToNative('LOG_MESSAGE', { message: JSON.stringify(args) });
      };
      console.log('\x1b[33m%s\x1b[0m', 'LoggerClient routing to native console');
    }
  }, []);

  return null;
};
